import { InjectionToken } from '@angular/core';

export * from './common';
export const IMAGE_BASE_URL = new InjectionToken<string>('IMAGE_BASE_URL');